export default __webpack_public_path__ + "images/3bc89231c2932ed08d5b019038eea45f.svg";